/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_SubmittingInputs */

const he_contact_form_submitting = /** @type {(inputs: Contact_Form_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שולח...`)
};

const en_contact_form_submitting = /** @type {(inputs: Contact_Form_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending...`)
};

/**
* | output |
* | --- |
* | "Sending..." |
*
* @param {Contact_Form_SubmittingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_form_submitting = /** @type {((inputs?: Contact_Form_SubmittingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_SubmittingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_form_submitting(inputs)
	return en_contact_form_submitting(inputs)
});